import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'c-multi-checkbox-item',
    templateUrl: './multi-checkbox-item.component.html',
    styleUrl: './multi-checkbox-item.component.css',
    standalone: false
})
export class MultiCheckboxItemComponent {
  /** @description La data a procesar */
  @Input() data!: any;

  @Input() check = false;
  @Input() itemProperty!: string;

  returnName(item: any) {
    return this.itemProperty ? item[this.itemProperty] : item;
  }

  @Output() selectedData = new EventEmitter<{ status: boolean; data: any }>();
  selectedItem(check: boolean) {
    this.selectedData.emit({ status: check, data: this.data });
  }
}
